import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="search-logging"
// Fires a fire-and-forget beacon when a search result is opened, so we can learn
// which results users actually click. The clicked link carries the data.
export default class extends Controller {
	static values = { url: String };

	log(event) {
		const { searchableType, searchableId, position, searchQueryId, section } = event.currentTarget.dataset;
		if (!searchableType || !searchableId) return;

		const data = new FormData();
		data.append("searchable_type", searchableType);
		data.append("searchable_id", searchableId);
		if (position) data.append("position", position);
		if (searchQueryId) data.append("search_query_id", searchQueryId);
		if (section) data.append("section", section);

		navigator.sendBeacon(this.urlValue, data);
	}
}
